import {CMSContentType} from "../CMSType";
import {BaseListContentParams, BaseListContent} from "./list.abstract.content";
import {AContentDTO} from "../base.content";
import {DetailsContent, DetailsItemsDTO, DetailsParams} from "./details.content";
import {BaseContentItemParams, BaseContentItem, BaseListImage} from "./base.content";
import {BaseContentItemDTO} from "./base.content";

export class ListItemImage extends BaseListImage {

}

export interface ListContentItemDTO extends BaseContentItemDTO {
  details: DetailsItemsDTO[];
}

export interface ListContentItemParams extends BaseContentItemParams {
  details: DetailsParams;
  avatar?: ListItemImage;
}

export class ListContentItem extends BaseContentItem {
  public readonly details: DetailsContent;
  public readonly avatar: ListItemImage;

  constructor(data: ListContentItemParams) {
    super(data);
    this.details = new DetailsContent(data.details);
  }

  public toJSON(): ListContentItemParams {
    const { details, avatar } = this;
    return {
      ...super.toJSON(),
      avatar,
      details: details.toParams()
    };
  }
}

export interface ListContentParams extends BaseListContentParams<ListContentItem> {

}

export interface ListContentDTO extends AContentDTO {
  items: ListContentItemDTO[];
}

export class ListContent extends BaseListContent<ListContentItem> {
  constructor(data: ListContentParams) {
    super(CMSContentType.list, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/list.content.ts